import axios from 'axios';
import invariant from 'tiny-invariant';

async function cacheCity(cityIndex) {
  invariant(cityIndex, 'cityIndex not found');

  const { data } = await axios.post(
    '/api/cities/cache-city',
    { cityIndex },
    {
      headers: {
        Authorization: process.env.NEXT_PUBLIC_API_KEY,
      },
    }
  );

  return data;
}

export default cacheCity;
